import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Ease of Editing",
description: "Learn how to make editing easier in Freon using reference shortcuts and triggers, simplifying user interactions and streamlining expression editing in the projectional editor.",
tags: [ "ease of editing", "reference shortcuts", "triggers", "projectional editor", "expressions", "user experience", "Freon", "DSL development"] ,
modifiedTime: "2025-11-07T17:39:02.349Z",
publishedTime: "2025-11-07T17:20:18.610Z"
    }
  };
};